import type { FC} from 'react';
import { memo } from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import Close from '@mui/icons-material/Close';
import { FormHelperText, IconButton, TextField } from '@mui/material';

import { InputPhone } from '@shared/ui';

import { onChangeValidator } from 'library/helpers/events';

import * as st from './Address.module.scss';

interface Props {
	isDisabled: boolean;
	handler: () => void;
}

const Address: FC<Props> = ({ isDisabled, handler }) => {
	const { control } = useFormContext();
	return (
		<fieldset className={st.address} disabled={isDisabled}>
			<div className={st.wrapper}>
				<div className={st.wrapper__left}>
					<Controller
						control={control}
						name={`address.city`}
						render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
							<TextField
								label="Город"
								type="text"
								size="small"
								InputLabelProps={{ shrink: true }}
								value={value}
								onBlur={onBlur}
								onChange={(event) => {
									onChangeValidator(event, value, onChange);
								}}
								error={!!error}
								helperText={error?.message ?? ' '}
								sx={{ minWidth: '250px' }}
							/>
						)}
					/>
					<Controller
						control={control}
						name={`address.street`}
						render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
							<TextField
								label="Улица/Проспект/Переулок"
								type="text"
								size="small"
								InputLabelProps={{ shrink: true }}
								value={value}
								onBlur={onBlur}
								onChange={(event) => {
									onChangeValidator(event, value, onChange);
								}}
								error={!!error}
								helperText={error?.message ?? ' '}
							/>
						)}
					/>
					<div className={st.wrapper__left_nums}>
						<Controller
							control={control}
							name={`address.house`}
							render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
								<TextField
									label="Дом"
									type="text"
									size="small"
									InputLabelProps={{ shrink: true }}
									value={value}
									onBlur={onBlur}
									onChange={(event) => {
										onChangeValidator(event, value, onChange);
									}}
									error={!!error}
									helperText={error?.message ?? ' '}
								/>
							)}
						/>
						<Controller
							control={control}
							name={`address.apartment`}
							render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
								<TextField
									label="Кв./Офис"
									type="text"
									size="small"
									InputLabelProps={{ shrink: true }}
									value={value}
									onBlur={onBlur}
									onChange={(event) => {
										onChangeValidator(event, value, onChange);
									}}
									error={!!error}
									helperText={error?.message ?? ' '}
								/>
							)}
						/>
					</div>
				</div>
				<div className={st.wrapper__right}>
					<div className={st.phone}>
						<Controller
							name="address.phone"
							control={control}
							render={({ field: { onChange, value }, fieldState: { error } }) => (
								<>
									<InputPhone value={value} onChange={onChange} label="Телефон" error={!!error} />
									<FormHelperText sx={{ marginLeft: '14px' }} error={!!error}>
										{error?.message ?? ' '}
									</FormHelperText>
								</>
							)}
						/>
					</div>
					<Controller
						name="address.note"
						control={control}
						render={({ field: { onChange, value, onBlur } }) => (
							<TextField
								label="Комментарий для клиента"
								value={value}
								onBlur={onBlur}
								onChange={(event) => {
									onChangeValidator(event, value, onChange);
								}}
								multiline
								rows={3.5}
								fullWidth
								className={st.textarea}
								InputLabelProps={{ shrink: true }}
							/>
						)}
					/>
				</div>
				<IconButton className={st.close} type="button" disabled={isDisabled} onClick={handler}>
					<Close />
				</IconButton>
			</div>
		</fieldset>
	);
};

export default memo(Address);
